import { createFlow } from "@Libs/Flow/services/createFlow";
import { IServiceRequest } from "../types";

export const ServiceRequestFlow = createFlow<
  undefined,
  { serviceRequest?: IServiceRequest }
>({
  root: "ROOT",
  state: {
    serviceRequest: undefined,
  },
});
